export const Desc = ({ children }) => {
  return <p className="desc">{children}</p>;
};
